import { localStorageKeys } from '@sketch/constants'
import { useGetDiscoverHashQuery } from '@sketch/gql-types'
import { useCallback } from 'react'
import { useLocalStorage } from 'react-use'

export const useDiscover = (workspaceId: string) => {
  const storageKey = localStorageKeys.discoverLastContentHash

  const [currentHash, setCurrentHash] = useLocalStorage(storageKey)
  const { data } = useGetDiscoverHashQuery()

  const fileHash = data?.discover.contentHash ?? ''
  const hasNewContent = fileHash !== currentHash

  const setViewedDiscover = useCallback(() => {
    setCurrentHash(fileHash)
  }, [fileHash, setCurrentHash])

  return {
    hasNewContent,
    setViewedDiscover,
  }
}
